import react, { useEffect } from "react"
import "./admin.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSession, selectAdminToken, selectSessionId, selectOrganizationId } from "./sessionSlice";
import AdminTour from "./tour/AdminTour";

const ADMIN_GAME_ID_KEY = "adminGameId";

function Admin({children}){
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const adminToken = useSelector(selectAdminToken);
  const currentSessionId = useSelector(selectSessionId);
  const currentOrganizationId = useSelector(selectOrganizationId);

  // Initialize session from URL parameters for regular admins
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const sessionIdFromUrl = searchParams.get('sessionId');
    const organizationIdFromUrl = searchParams.get('organizationId');
    const gameIdFromUrl = searchParams.get('gameId');
    // The redirect URL is the only place the admin learns the game id (the player's
    // sessionStorage is not shared with this page), so keep it for the header link.
    if (gameIdFromUrl) localStorage.setItem(ADMIN_GAME_ID_KEY, gameIdFromUrl);
    
    console.log('[Admin] URL params:', { sessionIdFromUrl, organizationIdFromUrl });
    console.log('[Admin] Current session:', { currentSessionId, adminToken });
    console.log('[Admin] location.search:', location.search);
    
    if (sessionIdFromUrl && organizationIdFromUrl) {
      // Regular admin coming from redirect - set session from URL params
      console.log('[Admin] Setting session from URL params:', { sessionIdFromUrl, organizationIdFromUrl });
      dispatch(setSession({ sessionId: sessionIdFromUrl, organizationId: organizationIdFromUrl }));
    } else if (location.pathname.includes('/admin') && !location.search) {
      // No URL params on admin page - log warning
      console.warn('[Admin] No URL params found. If this is a regular admin, they should have been redirected with session params.');
    }
  }, [location.search, location.pathname, dispatch]);

 const urlParams = new URLSearchParams(location.search);
 const sessionPending = Boolean(
   urlParams.get('sessionId') && urlParams.get('organizationId') &&
   (urlParams.get('sessionId') !== currentSessionId || urlParams.get('organizationId') !== currentOrganizationId)
 );

 const raw = location.pathname;
 const cleaned = raw.endsWith("/") && raw !== "/" ? raw.slice(0, -1) : raw;
 const isRootAdmin = cleaned === "/admin";
 const isSuperAdmin = currentSessionId === 'admin';

 console.log('[Admin] Render - isSuperAdmin:', isSuperAdmin, 'sessionId:', currentSessionId);

      const redirectGameSession = () => {
        let gameId = new URLSearchParams(location.search).get("gameId") || localStorage.getItem(ADMIN_GAME_ID_KEY);
        if (!gameId) {
          try {
            const stored =
              sessionStorage.getItem("userData") || localStorage.getItem("userData");
            gameId = stored ? JSON.parse(stored)?.gameId : null;
          } catch {
            /* ignore bad storage */
          }
        }
        const base = String(process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
        window.location.href = gameId && gameId !== "null" && gameId !== "undefined"
          ? `${base}/active-games/${encodeURIComponent(gameId)}`
          : base;
      };

      return <div className="admin-background">
       <div className="header-admin">
        {/* {!isRootAdmin && (
          <div className="back-button-holder">
              <button
                className="back-button"
                onClick={() => navigate(-1)}
              >
              <i className="fa-solid fa-arrow-left"></i> Back
              </button>
          </div>
        )} */}

         <div className="brand-logo-and-game-holder">
          <div className="brand-logo-holder" onClick={()=>{window.location.href = process.env.REACT_APP_BASE_URL;}}>
          <img src="/admin/play.png" className="brand-logo"/>{isSuperAdmin && " SUPERADMIN"}
         </div>
         <div onClick={()=>{redirectGameSession()}}>Collaborative Canvas </div>
          
         </div>
       
         
         <div className="user">
            <img src="/admin/user.png"/>
         </div>
       </div>
       {/* Child pages fetch theme data as soon as they mount (child effects run BEFORE the effect
           above), so on a redirect they used to fetch with the previous/empty session and the
           admin had to refresh to see the real theme. Hold them until the URL session is stored. */}
       {sessionPending ? null : children}
       <AdminTour />
      </div>
}

export default Admin;
